import { motion } from 'framer-motion'

import CareerHeroSection from '../../organisms/CareerHeroSection/CareerHeroSection'
import WhyEngineers from '../../molecules/WhyEngineers/WhyEngineers'
import QualitiesSection from '../../molecules/QualitiesSection/QualitiesSection'
import OpenPositions from '../../molecules/OpenPositions/OpenPositions'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import careerFooterImage from '../../../assets/images/career/team.webp'

const CareerPage = () => {
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: '-100px' },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  }

  return (
    <main className="min-h-screen bg-[#0E0924] text-white">
      <CareerHeroSection />

      <motion.div {...fadeUp}>
        <WhyEngineers />
      </motion.div>

      <motion.div {...fadeUp}>
        <OpenPositions />
      </motion.div>

      <motion.div {...fadeUp}>
        <QualitiesSection />
      </motion.div>
      <CommanFooterCard
 paragraph="Careers here mean ownership, mentorship, and space to solve hard engineering problems."
imageSrc={careerFooterImage}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #c9853c 0.11%, rgba(247, 127, 0, 0) 100%)"
/>
      <motion.div {...fadeUp}>
        <Testimonial className="mx-auto mb-20 max-w-[90%]" />
      </motion.div>

      <motion.div {...fadeUp}>
        <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message />
            <Questions />
          </div>
        </div>
      </motion.div>
        <Footer />
    </main>
  )
}

export default CareerPage
